import { render } from "./ViewPropositionReponsePage.vue?vue&type=template&id=70298dd2&ts=true"
import script from "./ViewPropositionReponsePage.vue?vue&type=script&lang=ts"
export * from "./ViewPropositionReponsePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__